export default "__VITE_ASSET__1fd8f350__"